<template>
    <div class="result-detail">
		<div class="contents">
			<h3 class="mark">
				<div class="type">
					<span>
						<img src="../assets/result-detail-output-icon01.svg" alt="*" />あなたのアウトプット性質
					</span>
				</div><!-- end .type -->
				<div class="cover">
					創出型{{outputResult.percentageLeft}}%、操縦型{{outputResult.percentageRight}}%
				</div><!-- end .cover -->
			</h3><!-- end .mark -->
			<div class="sentence">
				<div class="catch">
					<span class="left">
						Detailed
					</span>
					<span class="right">
						explanation
					</span>
				</div><!-- end .catch -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr01 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>マニュアルや指示通りのアウトプット習慣から逸脱すれば、あなたの未来は大きく変化する</h2>
				<img src="../assets/result-detail-output-inright01.svg" alt="*" class="visual" />
				<div class="caption">
					あなたは現状ではマニュアル通りで、指示が明確に存在するアウトプットに比重を置いている
				</div><!-- end .caption -->
				<p>この項目では、あなたのアウトプットの経験値や能力について検査しました。内向度が高いあなたは、アウトプットを繰り返すことが生きがいとなり、ストレスの発散に繋がります。なぜなら、内向度が高いあなたは、心や脳に溜め込むものが非常に多いからです。だから、想いやアイデアを吐き出すことで、心や脳がすっきりし、達成感を得られ、それがあなたの幸福度を高めるのです。</p>
				<p>あなたのアウトプット気質は、操縦型の傾向があることが分かりました。自らクリエイティブなアウトプットをするよりも、決まりきったマニュアル通りにこなすことのほうに経験が豊富です。アウトプットの質や種類を変えるだけで、まだまだあなたにはよりよい変革が待っていると言えるでしょう。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr02 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<h2>自分の価値観や想像力をもっと自分勝手にアウトプットしていけば、自分の内向性にマッチした人生を送りやすくなる</h2>
				<img src="../assets/result-detail-output-inright02.svg" alt="*" class="visual" />
				<div class="caption">
					本来、内向型は、操縦型のアウトプットよりも、創出型のアウトプットで強みを出すことができる
				</div><!-- end .caption -->
				<p>内向度が高いあなたは、あなたが想っている以上にクリエイティブな潜在能力を秘めています。アウトプットの質は、内部に秘めている思考力や想像力に大きく依存されます。内向性の高い人は、内省を含むインプットが豊かな人生を過ごします。だから、アウトプットも自然に豊かになります。</p>
				<p>しかしながら、操縦型のタイプは、これまで過ごしてきた環境からか、自身のインプットを生かす機会が少なく、逆に、既にマニュアルがあったり、周囲から言われたりすることを、そのまま行う経験だけが突出して増えてしまっているのです。</p>
				<p>今からでもまったく遅くはありません。ぜひ、自分の価値観や想像力をもっと自分勝手にアウトプットする機会を増やしてみて下さい。ブログ、文章創作、絵画、写真、陶芸など、なんでも構いません。</p>
				<p>仕事のような人生を費やす時間も、自分の価値観や想像力を積極的に扱える場に適性があると言えます。例えば、営業職であれば、マニュアル通りに対応する仕事ではなく、自分でプランや企画を提案できる仕事が良いでしょう。</p>
				<p>規則やマニュアルを操縦する環境と、培った思考やスキルで創造していく環境では、あなたの得られる評価、幸福度、達成感は大きく変わってくるはずです。</p>
				<!-- ////////////////////////////////////////////////////////////////////////// -->
				<!-- ++++++++++++++++++++++++++++++ Paragraphr03 ++++++++++++++++++++++++++++++ -->
				<!-- ////////////////////////////////////////////////////////////////////////// -->	
				<h2>スキル is キング、内向型のあなたはスキルを磨くことで、ハイモチベーションになれる</h2>
				<img src="../assets/result-detail-output-inright03.svg" alt="*" class="visual" />
				<div class="caption">
					スキルを高めれば、自由に扱える物事が増え、内向型の弱みが消え、強みが大きく増していく
				</div><!-- end .caption -->
				<p>内向度が高く、アウトプットが操縦型の人は、自分の個性や創造性にあまり自信を持てない人が多い傾向にあります。</p><p>自分の意思が否定されることを恐れ、相手の意思で動くことのほうが精神的で楽だと感じているかもしれません。マニュアルなどの理解度も高いため、言われたことをこなすのが得意なため、自分で何かを見出す機会が減っている人も少なくありません。</p>
				<p>あなたの内向的想像力を生かすための魔法の言葉は「スキル is キング」と言えるでしょう。とにかく、スキルを高めることから逃げない、こうしたマインドが、あなたの人生を勝手に創造的にしていきます。</p>
				<p>スキルがあれば、自己肯定感が高まります。スキルの違いに相手が気づけば、自然にあなたに、「あなたの思うようにやって下さい」と頼まれることが増えてきます。自分の思考力や想像力を気ままに使うことに価値が生まれるのです。</p>
				<p>1つの会社や団体の中の独自なスキルを磨くよりも、どの場面でも通用するスキルを磨くことで、あなたはより自身の内向性を活用できるようになります。専門家やフリーランスとして、個人で勝負する際に武器になるようなスキルを磨くと良いでしょう。</p>
				<p>スキルを高めることこそが、あなたのようなタイプが、最終的には、気楽に自分らしく過ごせることへ繋がっていきます。</p>
				<p>ぜひ、日々、何かのスキルと向き合うことを諦めないで下さい。内向度が高い人は、1つのスキルを別のスキルに応用することも非常に長けています。あなたの様々な想い(ウィル)は、スキルと向き合う人生で、次々と叶えられていくでしょう。</p>
			</div><!-- end .sentence -->
		</div><!-- end .guidance -->
    </div><!-- end .result-index -->				
</template>

<script>


export default {
	name: 'ResultDetailOutputInRight',
	components: {

	},
	
	data: function () {
		return {

		}
	},
	props:[

	],
	computed: {
		//level
		levelResult:function(){
			return this.$store.getters.levelResult
		},		
		// output
		outputResult:function(){
			return this.$store.getters.outputResult
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">



</style>
